import React from "react";
import "./Visitors.css";

const Visitors = () => {
  return (
    <div className="visitors">
      <div className="analytics-header">
        <h1>Visitor Analytics</h1>
      </div>
      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="card-icon total">
            <span className="material-icons">visibility</span>
          </div>
          <div className="card-content">
            <h3>Total Visitors</h3>
            <p className="metric-value">15,842</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon today">
            <span className="material-icons">today</span>
          </div>
          <div className="card-content">
            <h3>Today</h3>
            <p className="metric-value">342</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon unique">
            <span className="material-icons">person</span>
          </div>
          <div className="card-content">
            <h3>Unique Visitors</h3>
            <p className="metric-value">12,450</p>
          </div>
        </div>
        <div className="analytics-card">
          <div className="card-icon bounce">
            <span className="material-icons">exit_to_app</span>
          </div>
          <div className="card-content">
            <h3>Bounce Rate</h3>
            <p className="metric-value">42%</p>
          </div>
        </div>
      </div>
      <div className="info-message">
        <span className="material-icons">info</span>
        <p>Visitor analytics dashboard coming soon with detailed traffic insights</p>
      </div>
    </div>
  );
};

export default Visitors;
